import React, { useState, useEffect } from 'react';
import { fetchMileageHistory, addMileageRecord } from '../services/api';

interface MileageTrackerProps {
  carId: number;
  onUpdate?: () => void;
}

const MileageTracker: React.FC<MileageTrackerProps> = ({ carId, onUpdate }) => {
  const [history, setHistory] = useState<any[]>([]);
  const [newMileage, setNewMileage] = useState('');
  const [newDate, setNewDate] = useState(new Date().toISOString().split('T')[0]);
  const [loading, setLoading] = useState(true);

  const loadHistory = async () => {
    try {
      const data = await fetchMileageHistory(carId);
      setHistory(data);
    } catch (error) {
      console.error("Error loading mileage history", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadHistory();
  }, [carId]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await addMileageRecord({
        car_id: carId,
        mileage: parseInt(newMileage),
        date: newDate
      });
      setNewMileage('');
      loadHistory();
      if (onUpdate) onUpdate();
    } catch (error) {
      alert("Error al registrar kilometraje");
    }
  };

  if (loading) return <div>Cargando historial...</div>;

  return (
    <div className="mileage-tracker">
      <h3>Seguimiento de Kilometraje</h3>
      
      <form onSubmit={handleSubmit} className="form-inline" style={{ marginBottom: '1.5rem', display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
        <input 
          type="number" 
          placeholder="KM actuales" 
          className="form-control"
          value={newMileage}
          onChange={(e) => setNewMileage(e.target.value)}
          required
        />
        <input 
          type="date" 
          className="form-control"
          value={newDate}
          onChange={(e) => setNewDate(e.target.value)}
          required
        />
        <button type="submit" className="btn btn-primary">Actualizar</button>
      </form>

      <div className="history-list" style={{ maxHeight: '200px', overflowY: 'auto' }}>
        <table className="table" style={{ width: '100%', fontSize: '0.9rem' }}>
          <thead>
            <tr>
              <th>Fecha</th>
              <th>Kilometraje</th>
              <th>Diferencia</th>
            </tr>
          </thead>
          <tbody>
            {history.map((record, index) => {
              const nextRecord = history[index + 1];
              const diff = nextRecord ? record.mileage - nextRecord.mileage : null;
              return (
                <tr key={record.id}>
                  <td>{new Date(record.date).toLocaleDateString()}</td>
                  <td>{parseInt(record.mileage).toLocaleString()} KM</td>
                  <td style={{ color: '#666' }}>{diff !== null ? `+${diff.toLocaleString()}` : '-'}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MileageTracker;
